module.exports = __webpack_public_path__ + "static/media/safe.7b9b9232.svg";